module.exports = __webpack_public_path__ + "static/one_comm_index-341011b18b7b5fd5773bdd30023a6347.jpg";